<template><svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
  <g transform="translate(7.5, 7.5)">
    <circle class="a" cx="7.5" cy="7.5" r="7.5" fill="none" stroke="currentColor" stroke-width=".8" />
    <circle class="a" cx="7.5" cy="7.5" r="7" fill="none" stroke="currentColor" stroke-width=".8"/>
    <path class="a" d="M12.5 12.5l5 5" fill="none" stroke="currentColor" stroke-width=".8"/>
  </g>
</svg>
</template>